import React, { useEffect, useState } from 'react';
import Footer from '../../components/Footer/Footer';
import InstagramSection from '../../components/BrandHomePage/InstagramSection';
import SmartNavigation from '../../components/Navigation/SmartNavigation';
import { images } from '../../components/shared/assets';
import { initializeAllFeatures } from '../../utils/interactiveFeatures';
import { useOverlayManager } from '../../contexts/OverlayContext';
import './GalleryIguazu.css';

// Iguazu-specific gallery images (using local assets)
const iguazuGalleryImages = [
  { src: '/assets/images/gallery-iguazu-landscape.png', alt: 'Iguazu Landscape' },
  { src: '/assets/images/destinationsIguazu.png', alt: 'Awasi Iguazu Lodge' },
  { src: '/assets/images/packageCollage1.png', alt: 'Waterfall Vista' },
  { src: '/assets/images/packageCollage2.png', alt: 'Jungle View' },
  { src: '/assets/images/packageCollage3.png', alt: 'Forest Trail' },
  { src: '/assets/fullviewportiguazu.jpg', alt: 'Awasi Iguazu Villa' },
  { src: '/assets/iguazu-factsheet-hero.jpg', alt: 'Lodge Reflection' },
  { src: '/assets/experiencepagebreak.jpg', alt: 'Iguazu Experience' },
  { src: '/assets/images/video1.png', alt: 'Waterfall Tour' },
  { src: '/assets/images/video2.png', alt: 'Jungle Hiking' },
  { src: '/assets/images/video3.png', alt: 'River Excursion' },
  { src: '/assets/images/video4.png', alt: 'Wildlife Viewing' }
];

const GalleryIguazu: React.FC = () => {
  const { setHoveredDestination } = useOverlayManager();
  const [selectedFilter, setSelectedFilter] = useState<string | null>(null);

  // Initialize features and clear hover state
  useEffect(() => {
    window.scrollTo(0, 0);
    const cleanup = initializeAllFeatures();
    setHoveredDestination(null);
    return cleanup;
  }, [setHoveredDestination]);

  return (
    <div className="gallery-iguazu-page">
      {/* Navigation with light variant for Iguazu */}
      <SmartNavigation forceVariant="light" />

      {/* Hero Section */}
      <div
        className="gallery-hero-section"
        data-scroll-section="hero"
        style={{
          backgroundImage: `url('/assets/iguazu-factsheet-hero.jpg')`
        }}
      >
        <div className="gallery-hero-overlay">
          <h1 className="gallery-hero-title">Awaken to Unforgettable Views</h1>
          <p className="gallery-hero-subtitle">Take a seat in the front row, watching the theatre of Mother Nature unfold.</p>
        </div>
      </div>

      {/* Filter Bar */}
      <div className="gallery-filter-bar" data-scroll-section="filters">
        <div className="gallery-filters">
          <button
            className={`filter-button ${selectedFilter === 'iguazu' ? 'active' : ''}`}
            onClick={() => setSelectedFilter(selectedFilter === 'iguazu' ? null : 'iguazu')}
          >
            IGUAZU +
          </button>
          <button
            className={`filter-button ${selectedFilter === 'type' ? 'active' : ''}`}
            onClick={() => setSelectedFilter(selectedFilter === 'type' ? null : 'type')}
          >
            TYPE +
          </button>
        </div>
      </div>

      {/* Gallery Grid */}
      <div className="gallery-grid-section" data-scroll-section="gallery-grid">
        <div className="gallery-grid">
          {iguazuGalleryImages.map((image, index) => (
            <div
              key={index}
              className={`gallery-item gallery-item--${(index % 4) + 1}`}
              data-scroll-animation="fade-up"
            >
              <img src={image.src} alt={image.alt} />
            </div>
          ))}
        </div>
      </div>

      {/* Instagram Section */}
      <div data-scroll-section="instagram">
        <InstagramSection
          posts={[
            { src: images.instagram1, alt: "Iguazu Instagram 1" },
            { src: images.instagram2, alt: "Iguazu Instagram 2", isVideo: true },
            { src: images.instagram3, alt: "Iguazu Instagram 3" },
            { src: images.instagram4, alt: "Iguazu Instagram 4" }
          ]}
        />
      </div>

      {/* Footer with Iguazu variant */}
      <Footer variant="iguazu" />
    </div>
  );
};

export default GalleryIguazu;